module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/197-melilla-12fb921420ff352260dd867d720f200e.svg";